module.exports = __webpack_public_path__ + "static/defaultnewprojecttab-704155ffa1d84d77ed99826f89e0c017.png";